export abstract class CreateErrorBase {
  public abstract readonly messageHeader: string;
  public abstract readonly message: string;
  public abstract readonly error: any;
  public readonly config: Record<string, unknown>;
  public toError(): string {
    return '';
  }
}

export class CreateRenewTokenError extends CreateErrorBase {
  public readonly messageHeader: string;
  public readonly message: string;
  public readonly error: any | null;
  public readonly config: Record<string, unknown>;

  constructor(init: {
    error?: any;
    messageHeader?: string;
    message?: string;
    config?: Record<string, unknown>;
  }) {
    super();
    this.error = init?.error;
    this.messageHeader = init?.messageHeader || 'Create account failed';
    this.message = init?.message;
    this.config = init?.config;
  }
}

export class CreateError extends CreateErrorBase {
  public readonly messageHeader: string;
  public readonly message: string;
  public readonly error: any | null;
  public readonly config: Record<string, unknown>;

  constructor(init: {
    error: any | null;
    messageHeader?: string;
    message?: string;
    config?: Record<string, unknown>;
  }) {
    super();
    this.error = init?.error;
    this.messageHeader = init?.messageHeader || 'Create account failed';
    this.message = init?.message;
    this.config = init?.config;
  }

  public toError(): string {
    return this.error?.status === 409
      ? (this.config?.message as string)
      : this.message;
  }
}

export class BootstrapError extends CreateErrorBase {
  public readonly messageHeader: string;
  public readonly message: string;
  public readonly error: any | null;
  public readonly config: Record<string, unknown>;

  constructor(init: {
    error: any | null;
    messageHeader?: string;
    message?: string;
    config?: Record<string, unknown>;
  }) {
    super();
    this.error = init?.error;
    this.messageHeader = init?.messageHeader || 'Create account failed';
    this.message = init?.message;
  }
}

export class InviteAdminError extends CreateErrorBase {
  public readonly messageHeader: string;
  public readonly message: string;
  public readonly error: any | null;
  public readonly config: Record<string, unknown>;

  constructor(init: {
    error: any | null;
    messageHeader?: string;
    message?: string;
    config?: Record<string, unknown>;
  }) {
    super();
    this.error = init?.error;
    this.messageHeader = init?.messageHeader || 'Create account failed';
    this.message = init?.message;
    this.config = init?.config;
  }
}

export class LogError extends CreateErrorBase {
  public readonly messageHeader: string;
  public readonly message: string;
  public readonly error: any | null;

  constructor(init: {
    error: any | null;
    messageHeader?: string;
    message?: string;
  }) {
    super();
    this.error = init?.error;
    this.messageHeader = init?.messageHeader || 'Logging failed';
    this.message = init?.message;
  }
}
